import { memo } from 'react';

import { ChevronDownIcon } from '@air/design-icons';
import { FileStatusButton } from '@air/feature-file-status/ui';

import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type TaskPaneCancelOrHideButtonProps = {
  onClick: () => void;
};

export const TaskPaneCancelOrHideButton = memo(({ onClick }: TaskPaneCancelOrHideButtonProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();

  if (ui2026) {
    return <TaskPaneDismissButton label="Hide" onClick={onClick} />;
  }

  return (
    <FileStatusButton label="Hide" onClick={onClick}>
      <ChevronDownIcon size="sm" />
    </FileStatusButton>
  );
});

TaskPaneCancelOrHideButton.displayName = 'TaskPaneCancelOrHideButton';
